import NotesList from './NotesList.js';

export default NotesList;
